/**
 * Accessibility specifications
 *
 * @url Accessibility https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion/
 */
//@ts-nocheck
'use client'

import React, { memo, useContext, useState } from 'react'
import * as S from './Accordion.styles'

import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'

import Accordion from './AccordionSub.component'

import generateIdFromText from '@caffeina-siad/utils/src/generate-id-from-text'

type AccordionVariant = 'base' | 'twoColumns'

interface AccordionItem {
  id?: string
  title: string
  answer?: string
  question?: string
}

interface AccordionListProps {
  variant?: AccordionVariant
  items?: AccordionItem[]
  multiple?: boolean
  withID?: boolean
  colorScheme: ColorSchemeTypes
}

interface AccordionProps {
  id: string | null
  variant: AccordionVariant
  data: AccordionItem
  colorScheme: ColorSchemeTypes
  open: boolean
  parentHandler: () => void
}

const AccordionList: React.FC<AccordionListProps> = ({ variant = 'base', items, multiple = false, withID }) => {
  const selectedColorScheme = useContext(SectionThemeContext)?.selectedColorScheme || 'green'

  const [expanded, setExpanded] = useState<number[]>([])

  const handleExpanded = (index: number, expanded: number[]): void => {
    if (expanded.indexOf(index) !== -1) {
      const indexOfExpanded = expanded.indexOf(index)
      const newExpanded = expanded
      newExpanded.splice(indexOfExpanded, 1)
      setExpanded(newExpanded)
    } else {
      const newExpanded = multiple ? [...expanded, index] : [index]
      setExpanded(newExpanded)
    }
  }

  return items ? (
    <S.AccordionList colorScheme={selectedColorScheme}>
      {items.map((item, index) => {
        const id = withID ? generateIdFromText(item.title) : null
        return (
          <Accordion
            id={withID ? id : null}
            variant={variant}
            data={item}
            colorScheme={selectedColorScheme}
            key={`accordionComponent-${item.id}`}
            open={expanded.indexOf(index) !== -1}
            parentHandler={() => handleExpanded(index, expanded)}
          />
        )
      })}
    </S.AccordionList>
  ) : null
}

export default memo(AccordionList)
